/**
 * Filter to remove the numbers and the hyphen from the start of the category names
 * Example: "01 - ABS" -> "ABS"
 * @param {string} categoryName - Category name
 * @returns {string} - Formatted category name
 */
export function formatCategoryName(categoryName) {
  if (!categoryName) return '';
  
  // Regex to remove numbers and a hyphen from the start of the name
  // Example: "01 - ABS" -> "ABS"
  return categoryName.replace(/^\d+\s*-\s*/, '').trim();
}

// Exports every filter for global use
export default {
  formatCategoryName
};
